import {
  Component,
  OnInit,
  ViewEncapsulation,
  AfterViewInit,
} from "@angular/core";
import { Helpers } from "../../../helpers";
import { appService } from "../../../_services/app.service";
import { Route, Router } from "@angular/router";
import { Toast } from "ngx-toastr";
declare var moment: any;
declare var jquery: any;
declare var $: any;
declare let mLayout: any;
import { ToastrService } from "ngx-toastr/";
import { environment } from "../../../../environments/environment";
import { TranslateConfigService } from "../../home/translateConfig.service";
import { TranslateService } from "@ngx-translate/core";
const LNG_KEY = "SELECTED_LANGUAGE";

@Component({
  selector: "app-aside-nav",
  templateUrl: "./aside-nav.component.html",
  encapsulation: ViewEncapsulation.None,
})
export class AsideNavComponent implements OnInit {
  hostUrl: any = environment.apiUrl;
  selectedLang: string;
  model: any = {};
  res: any;
  flag: any = true;
  systemSettingValue: any;
  static asideNavComponent: AsideNavComponent;
  // change kevin 08/09/2020
  eWayBillFlag: boolean = true;
  THCFlag: boolean = true;
  isTransporter: any;
  isCustomer: any;
  // end
  //add kevin 14/06/2021
  isFreightExport: any;
  //end
  fuelPumpFlag: boolean;
  SecondTripProceesLinkFormatFlag = false;
  Trip_assignVehicle_to_bookingCompleted_stageFlag = false;
  MultiPickupTripOnOffFlag: any = false;
  //added by vithujan 24-02-2023
  totalList: any = 0;
  listIndex: any = 0;
  submenuList: any = 0;
  submenuIndex: any = -1;
  isEnterPressed: boolean = false;
  liSubmenuList: any = 0;
  liSubmenuIndex: any = -1;
  ShowRouteOptimization: any = false;

  isPaymentDone: boolean = true;
  showPaymentAlert: boolean = false;
  DefaultCompanyId: any;
  Paymentmsg: any = [];

  constructor(
    private _appService: appService,
    private _router: Router,
    private _toastr: ToastrService,
    private service: TranslateConfigService,
    private translate: TranslateService
  ) {
    AsideNavComponent.asideNavComponent = this;
    let language = this.translate.getBrowserLang();
    let value = localStorage.getItem(LNG_KEY);
    if (value === "" || value === null || value === undefined) {
      this.translate.setDefaultLang(language);
      this.selectedLang = language;
    } else {
      this.service.setLanguage(value);
      this.selectedLang = value;
    }
    let val = localStorage.getItem(LNG_KEY);
    //added by vithujan 06-02-2023
    this.showHelpMenu();
    localStorage.removeItem('isEnterPressed');
    localStorage.removeItem('isArrowDownPressed');
    localStorage.removeItem('isArrowUpPressed');
    //end
  }
  ngOnInit() {
    // change kevin 08/09/2020
    this.eWayBillFlag = JSON.parse(localStorage.getItem("eWayBillFlag"));
    this.THCFlag = JSON.parse(localStorage.getItem("THCFlag"));
    this.isTransporter = JSON.parse(localStorage.getItem("isTransporter"));
    this.fuelPumpFlag = JSON.parse(localStorage.getItem("fuelPumpFlag"));
    this.SecondTripProceesLinkFormatFlag = JSON.parse(localStorage.getItem("SecondTripProceesLinkFormatFlag"));
    this.Trip_assignVehicle_to_bookingCompleted_stageFlag = JSON.parse(localStorage.getItem("Trip_assignVehicle_to_bookingCompleted_stageFlag"));
    this.MultiPickupTripOnOffFlag = JSON.parse(localStorage.getItem("MultiPickupTripOnOffFlag"));
    this.isCustomer = JSON.parse(localStorage.getItem("isCustomer"));

    // end
    //add kevin 14/06/2021
    this.isFreightExport = JSON.parse(localStorage.getItem("isFreightExport"));
    console.log('this.isFreightExport', this.isFreightExport);

    //end

    this.CheckForFuelPrice();
    this.LoadShowRouteOptimization();
    this.DefaultCompanyId = JSON.parse(localStorage.getItem("ChnageCompnayId")).DefaultCompanyId;
    this.GetPaymentDone();
    this.getpayementmessage();
    // this.refreshFuelName();
    // this._appService.Get("FuelPrice", "CheckFuelFlag").subscribe(Response => {
    //     this.flag = Response;
    //     Helpers.setLoading(false);
    //     if (this.flag == false) {
    //         this._router.navigate(['/index']);
    //         setTimeout(() => {
    //             (<any>$("#newFuel")).modal()
    //         }, 200);
    //     }

    // })
  }

  ngAfterViewInit() {
    // change kevin 08/09/2020
    this.eWayBillFlag = JSON.parse(localStorage.getItem("eWayBillFlag"));
    this.THCFlag = JSON.parse(localStorage.getItem("THCFlag"));
    // end
    mLayout.initAside();
  }

  CheckForFuelPrice() {
    Helpers.setLoading(false);
    this._appService
      .GetById("Common", "GetSystemSettingByName", "FuelPrice")
      .subscribe((response) => {
        this.systemSettingValue = response;
        if (this.systemSettingValue == "0") {
          this.refreshFuelName();
          this._appService
            .Get("FuelPrice", "CheckFuelFlag")
            .subscribe((Response) => {
              this.flag = Response;

              Helpers.setLoading(false);
              if (this.flag == false) {
                this._router.navigate(["/index"]);
                setTimeout(() => {
                  (<any>$("#newFuel")).modal();
                }, 200);
              }
            });
        } else {
          this.flag = true;
          Helpers.setLoading(false);
        }
      });
  }
  calcAverage() {
    let Total = 0;
    if (this.model.KolkataPrice == "" || this.model.KolkataPrice == undefined) {
      this.model.KolkataPrice = 0;
    }
    if (this.model.MumbaiPrice == "" || this.model.MumbaiPrice == undefined) {
      this.model.MumbaiPrice = 0;
    }
    if (this.model.ChennaiPrice == "" || this.model.ChennaiPrice == undefined) {
      this.model.ChennaiPrice = 0;
    }
    if (this.model.DelhiPrice == "" || this.model.DelhiPrice == undefined) {
      this.model.DelhiPrice = 0;
    }

    Total =
      (parseInt(this.model.MumbaiPrice) +
        parseInt(this.model.KolkataPrice) +
        parseInt(this.model.ChennaiPrice) +
        parseInt(this.model.DelhiPrice)) /
      4;

    this.model.Average = Total;
  }

  refreshFuelName() {
    $("#startdate").datepicker({
      defaultDate: new Date(),
      todayHighlight: true,
      orientation: "auto",
      autoclose: true,
      format: "dd/mm/yyyy",
      endDate: "+0d",
      templates: {
        leftArrow: '<i class="la la-angle-left"></i>',
        rightArrow: '<i class="la la-angle-right"></i>',
      },
    });
  }
  FuelPricePost() {
    this.model.Date = $("#startdate")
      .data("datepicker")
      .getFormattedDate("yyyy-mm-dd");

    if (this.model.Date == "") {
      this.model.Date = null;
    }
    Helpers.setLoading(true);
    this._appService.Post("FuelPrice", "SaveFuelData", this.model).subscribe(
      (response) => {
        this.res = response;
        if (this.res == true) {
          this._toastr.success("Save Successfully ", "Fuel Price");
          this.ngOnInit();
          Helpers.setLoading(true);
        } else {
          this._toastr.error("Same Date Data Can Not Be Save", "Fuel Price");
        }
      },
      (err) => {
        console.log("Error occured");
      }
    );
    $("#newFuel").modal("hide");
  }

  //added by vithujan 06-02-2023
  showHelpMenu() {
    document.addEventListener("keydown", function (zEvent) {

      if (zEvent.key === "F6") {
        zEvent.preventDefault();
        $('#menuList > li').eq(0).css("background-color", "white");
        $('#menuList > li').removeClass('m-menu__item--open');
        AsideNavComponent.asideNavComponent.listIndex = 0;
        AsideNavComponent.asideNavComponent.submenuIndex = -1;
        AsideNavComponent.asideNavComponent.liSubmenuIndex = -1;
        localStorage.setItem('isEnterPressed', 'true');
        localStorage.setItem('isArrowDownPressed', 'true');
        localStorage.setItem('isArrowUpPressed', 'true');

        $.each($('#menuList'), function () {
          var children = $(this).find(">li");
          AsideNavComponent.asideNavComponent.totalList = children.length;
        });
      }
      if (zEvent.key === "ArrowDown") {
        var value = localStorage.getItem('isArrowDownPressed');
        if (value == 'true') {
          zEvent.preventDefault();
          zEvent.stopImmediatePropagation();

          let element = $('#menuList > li').eq(AsideNavComponent.asideNavComponent.listIndex);
          //Check whether menu has opened
          if (element[0].classList.contains('m-menu__item--open')) {
            if ($('#menuList > li').eq(AsideNavComponent.asideNavComponent.listIndex).children('div').length > 0) {
              AsideNavComponent.asideNavComponent.submenuList = $('#menuList > li').eq(AsideNavComponent.asideNavComponent.listIndex).children('div').length;

              //if sub items count grater than total sub menu items count move on next main menu
              if (AsideNavComponent.asideNavComponent.submenuIndex >= (AsideNavComponent.asideNavComponent.submenuList - 1)) {

                var elem = $('#menuList > li').eq(AsideNavComponent.asideNavComponent.listIndex).children('div')
                  .eq(AsideNavComponent.asideNavComponent.submenuIndex).children('ul').children('li');

                if (!elem[0].classList.contains('m-menu__item--open')) {

                  $('#menuList > li').eq(AsideNavComponent.asideNavComponent.listIndex).children('div').eq(AsideNavComponent.asideNavComponent.submenuIndex).css("background-color", "#f2f3f8");

                  if (AsideNavComponent.asideNavComponent.listIndex >= (AsideNavComponent.asideNavComponent.totalList - 1)) {
                    AsideNavComponent.asideNavComponent.listIndex = (AsideNavComponent.asideNavComponent.totalList - 1);
                  }
                  if (AsideNavComponent.asideNavComponent.listIndex < (AsideNavComponent.asideNavComponent.totalList - 1)) {
                    AsideNavComponent.asideNavComponent.listIndex = (AsideNavComponent.asideNavComponent.listIndex + 1);

                    $('#menuList > li').eq(AsideNavComponent.asideNavComponent.listIndex).css("background-color", "white");
                    $('#menuList > li').eq(AsideNavComponent.asideNavComponent.listIndex - 1).css("background-color", "#f2f3f8");
                    $('#menuList > li').eq(AsideNavComponent.asideNavComponent.listIndex - 1).removeClass('m-menu__item--open');
                    $('#menuList > li').eq(AsideNavComponent.asideNavComponent.listIndex).children('div').css("background-color", "#f2f3f8");
                    AsideNavComponent.asideNavComponent.submenuIndex = -1;

                    window.scrollBy(0, 25);
                    return;
                  }
                }
              }

              //sub menu item index less than sub menu items count
              if (AsideNavComponent.asideNavComponent.submenuIndex <= (AsideNavComponent.asideNavComponent.submenuList - 1)) {

                var elem = $('#menuList > li').eq(AsideNavComponent.asideNavComponent.listIndex).children('div')
                  .eq(AsideNavComponent.asideNavComponent.submenuIndex).children('ul').children('li');

                if (elem[0].classList.contains('m-menu__item--open')) {
                  AsideNavComponent.asideNavComponent.liSubmenuList = $('#menuList > li').eq(AsideNavComponent.asideNavComponent.listIndex).children('div')
                    .eq(AsideNavComponent.asideNavComponent.submenuIndex).children('ul').children('li').children('div').length;

                  if (AsideNavComponent.asideNavComponent.liSubmenuIndex >= (AsideNavComponent.asideNavComponent.liSubmenuList - 1)) {
                    $('#menuList > li').eq(AsideNavComponent.asideNavComponent.listIndex).children('div')
                      .eq(AsideNavComponent.asideNavComponent.submenuIndex).css("background-color", "#f2f3f8");

                    if (AsideNavComponent.asideNavComponent.submenuIndex >= (AsideNavComponent.asideNavComponent.submenuList - 1)) {
                      AsideNavComponent.asideNavComponent.submenuIndex = (AsideNavComponent.asideNavComponent.submenuList - 1);

                      $('#menuList > li').eq(AsideNavComponent.asideNavComponent.listIndex).children('div').eq(AsideNavComponent.asideNavComponent.submenuIndex).css("background-color", "#f2f3f8");

                      if (AsideNavComponent.asideNavComponent.listIndex >= (AsideNavComponent.asideNavComponent.totalList - 1)) {
                        AsideNavComponent.asideNavComponent.listIndex = (AsideNavComponent.asideNavComponent.totalList - 1);
                      }
                      if (AsideNavComponent.asideNavComponent.listIndex < (AsideNavComponent.asideNavComponent.totalList - 1)) {
                        AsideNavComponent.asideNavComponent.listIndex = (AsideNavComponent.asideNavComponent.listIndex + 1);

                        $('#menuList > li').eq(AsideNavComponent.asideNavComponent.listIndex).css("background-color", "white");
                        $('#menuList > li').eq(AsideNavComponent.asideNavComponent.listIndex - 1).css("background-color", "#f2f3f8");
                        $('#menuList > li').eq(AsideNavComponent.asideNavComponent.listIndex - 1).removeClass('m-menu__item--open');
                        $('#menuList > li').eq(AsideNavComponent.asideNavComponent.listIndex).children('div').css("background-color", "#f2f3f8");
                        AsideNavComponent.asideNavComponent.submenuIndex = -1;

                        window.scrollBy(0, 25);
                      }

                    }
                    if (AsideNavComponent.asideNavComponent.submenuIndex < (AsideNavComponent.asideNavComponent.submenuList - 1)) {
                      AsideNavComponent.asideNavComponent.submenuIndex = (AsideNavComponent.asideNavComponent.submenuIndex + 1);

                      $('#menuList > li').eq(AsideNavComponent.asideNavComponent.listIndex).children('div')
                        .eq(AsideNavComponent.asideNavComponent.submenuIndex).css("background-color", "white");

                      $('#menuList > li').eq(AsideNavComponent.asideNavComponent.listIndex).children('div')
                        .eq(AsideNavComponent.asideNavComponent.submenuIndex - 1).css("background-color", "#f2f3f8");

                      $('#menuList > li').eq(AsideNavComponent.asideNavComponent.listIndex).children('div')
                        .eq(AsideNavComponent.asideNavComponent.submenuIndex - 1).children('ul').children('li').removeClass('m-menu__item--open');

                      $('#menuList > li').eq(AsideNavComponent.asideNavComponent.listIndex).children('div')
                        .eq(AsideNavComponent.asideNavComponent.submenuIndex).children('ul').children('li').children('div')
                        .eq(AsideNavComponent.asideNavComponent.liSubmenuIndex).css("background-color", "#f2f3f8");

                      AsideNavComponent.asideNavComponent.liSubmenuList = -1;
                      window.scrollBy(0, 25);
                      return;
                    }
                  }

                  if (AsideNavComponent.asideNavComponent.liSubmenuIndex <= (AsideNavComponent.asideNavComponent.liSubmenuList - 1)) {

                    $('#menuList > li').eq(AsideNavComponent.asideNavComponent.listIndex).children('div').eq(AsideNavComponent.asideNavComponent.submenuIndex).css("background-color", "#f2f3f8");
                    AsideNavComponent.asideNavComponent.liSubmenuIndex = (AsideNavComponent.asideNavComponent.liSubmenuIndex + 1);

                    $('#menuList > li').eq(AsideNavComponent.asideNavComponent.listIndex).children('div')
                      .eq(AsideNavComponent.asideNavComponent.submenuIndex).children('ul').children('li').children('div')
                      .eq(AsideNavComponent.asideNavComponent.liSubmenuIndex).css("background-color", "white");

                    $('#menuList > li').eq(AsideNavComponent.asideNavComponent.listIndex).children('div')
                      .eq(AsideNavComponent.asideNavComponent.submenuIndex).children('ul').children('li').children('div')
                      .eq(AsideNavComponent.asideNavComponent.liSubmenuIndex - 1).css("background-color", "#f2f3f8");

                    window.scrollBy(0, 8);
                    return;
                  }
                }

                AsideNavComponent.asideNavComponent.submenuIndex = (AsideNavComponent.asideNavComponent.submenuIndex + 1);

                $('#menuList > li').eq(AsideNavComponent.asideNavComponent.listIndex).children('div')
                  .eq(AsideNavComponent.asideNavComponent.submenuIndex).children('ul').children('li').css("background-color", "white");

                $('#menuList > li').eq(AsideNavComponent.asideNavComponent.listIndex).children('div')
                  .eq(AsideNavComponent.asideNavComponent.submenuIndex - 1).children('ul').children('li').css("background-color", "#f2f3f8");
                window.scrollBy(0, 8);
              }
            }
          } else {

            if (AsideNavComponent.asideNavComponent.listIndex >= (AsideNavComponent.asideNavComponent.totalList - 1)) {
              AsideNavComponent.asideNavComponent.listIndex = (AsideNavComponent.asideNavComponent.totalList - 1);
            }
            if (AsideNavComponent.asideNavComponent.listIndex < (AsideNavComponent.asideNavComponent.totalList - 1)) {
              AsideNavComponent.asideNavComponent.listIndex = (AsideNavComponent.asideNavComponent.listIndex + 1);

              $('#menuList > li').eq(AsideNavComponent.asideNavComponent.listIndex).css("background-color", "white");
              $('#menuList > li').eq(AsideNavComponent.asideNavComponent.listIndex - 1).css("background-color", "#f2f3f8");
              $('#menuList > li').eq(AsideNavComponent.asideNavComponent.listIndex - 1).removeClass('m-menu__item--open');

              window.scrollBy(0, 25);
            }
          }
        }
      }
      if (zEvent.key === "ArrowUp") {
        var value = localStorage.getItem('isArrowUpPressed');
        if (value == 'true') {
          zEvent.preventDefault();
          zEvent.stopImmediatePropagation();

          let element = $('#menuList > li').eq(AsideNavComponent.asideNavComponent.listIndex);
          //Check whether menu has opened
          if (element[0].classList.contains('m-menu__item--open')) {
            if ($('#menuList > li').eq(AsideNavComponent.asideNavComponent.listIndex).children('div').length > 0) {

              //if sub items count grater than total sub menu items count move on next main menu
              if (AsideNavComponent.asideNavComponent.submenuIndex <= 0) {
                $('#menuList > li').eq(AsideNavComponent.asideNavComponent.listIndex).children('div').eq(AsideNavComponent.asideNavComponent.submenuIndex).css("background-color", "#f2f3f8");

                if (AsideNavComponent.asideNavComponent.listIndex <= 0) {
                  AsideNavComponent.asideNavComponent.listIndex = 0;
                  return;
                }
                if (AsideNavComponent.asideNavComponent.listIndex < AsideNavComponent.asideNavComponent.totalList) {
                  AsideNavComponent.asideNavComponent.listIndex = (AsideNavComponent.asideNavComponent.listIndex - 1);

                  $('#menuList > li').eq(AsideNavComponent.asideNavComponent.listIndex).css("background-color", "white");
                  $('#menuList > li').eq(AsideNavComponent.asideNavComponent.listIndex + 1).css("background-color", "#f2f3f8");
                  $('#menuList > li').removeClass('m-menu__item--open');
                  $('#menuList > li').eq(AsideNavComponent.asideNavComponent.listIndex).children('div').css("background-color", "#f2f3f8");
                  window.scrollBy(0, -50);
                }
              }

              //
              if (AsideNavComponent.asideNavComponent.submenuIndex > 0) {
                var elem = $('#menuList > li').eq(AsideNavComponent.asideNavComponent.listIndex).children('div')
                  .eq(AsideNavComponent.asideNavComponent.submenuIndex).children('ul').children('li');

                if (elem[0].classList.contains('m-menu__item--open')) {
                  if (AsideNavComponent.asideNavComponent.liSubmenuIndex > 0) {

                    if (AsideNavComponent.asideNavComponent.liSubmenuIndex < AsideNavComponent.asideNavComponent.liSubmenuList) {
                      AsideNavComponent.asideNavComponent.liSubmenuIndex = (AsideNavComponent.asideNavComponent.liSubmenuIndex - 1);

                      $('#menuList > li').eq(AsideNavComponent.asideNavComponent.listIndex).children('div')
                        .eq(AsideNavComponent.asideNavComponent.submenuIndex).children('ul').children('li').children('div')
                        .eq(AsideNavComponent.asideNavComponent.liSubmenuIndex).css("background-color", "white");

                      $('#menuList > li').eq(AsideNavComponent.asideNavComponent.listIndex).children('div')
                        .eq(AsideNavComponent.asideNavComponent.submenuIndex).children('ul').children('li').children('div')
                        .eq(AsideNavComponent.asideNavComponent.liSubmenuIndex + 1).css("background-color", "#f2f3f8");

                      window.scrollBy(0, -50);
                      return;
                    }
                  } else {

                    AsideNavComponent.asideNavComponent.submenuIndex = (AsideNavComponent.asideNavComponent.submenuIndex - 1);

                    $('#menuList > li').eq(AsideNavComponent.asideNavComponent.listIndex).children('div')
                      .eq(AsideNavComponent.asideNavComponent.submenuIndex + 1).children('ul').children('li').removeClass('m-menu__item--open');

                    $('#menuList > li').eq(AsideNavComponent.asideNavComponent.listIndex).children('div')
                      .eq(AsideNavComponent.asideNavComponent.submenuIndex).children('ul').children('li').css("background-color", "white");

                    $('#menuList > li').eq(AsideNavComponent.asideNavComponent.listIndex).children('div')
                      .eq(AsideNavComponent.asideNavComponent.submenuIndex + 1).children('ul').children('li').css("background-color", "#f2f3f8");

                    $('#menuList > li').eq(AsideNavComponent.asideNavComponent.listIndex).children('div')
                      .eq(AsideNavComponent.asideNavComponent.submenuIndex).children('ul').children('li').children('div')
                      .eq(AsideNavComponent.asideNavComponent.liSubmenuIndex + 1).css("background-color", "#f2f3f8");

                    AsideNavComponent.asideNavComponent.liSubmenuIndex = -1;

                    window.scrollBy(0, -50);
                    return;
                  }
                }

                AsideNavComponent.asideNavComponent.submenuIndex = (AsideNavComponent.asideNavComponent.submenuIndex - 1);

                if (AsideNavComponent.asideNavComponent.submenuIndex == 0) {
                  $('#menuList > li').eq(AsideNavComponent.asideNavComponent.listIndex).children('div').css("background-color", "#f2f3f8");
                }

                $('#menuList > li').eq(AsideNavComponent.asideNavComponent.listIndex).children('div')
                  .eq(AsideNavComponent.asideNavComponent.submenuIndex).children('ul').children('li').css("background-color", "white");

                $('#menuList > li').eq(AsideNavComponent.asideNavComponent.listIndex).children('div')
                  .eq(AsideNavComponent.asideNavComponent.submenuIndex + 1).children('ul').children('li').css("background-color", "#f2f3f8");
                window.scrollBy(0, 8);

              }
            }
          } else {

            if (AsideNavComponent.asideNavComponent.listIndex <= 0) {
              AsideNavComponent.asideNavComponent.listIndex = 0;
              return;
            }
            if (AsideNavComponent.asideNavComponent.listIndex < AsideNavComponent.asideNavComponent.totalList) {
              AsideNavComponent.asideNavComponent.listIndex = (AsideNavComponent.asideNavComponent.listIndex - 1);

              $('#menuList > li').eq(AsideNavComponent.asideNavComponent.listIndex).css("background-color", "white");
              $('#menuList > li').eq(AsideNavComponent.asideNavComponent.listIndex + 1).css("background-color", "#f2f3f8");
              window.scrollBy(0, -25);
            }
          }
        }
      }
      if (zEvent.key === "Enter") {
        var value = localStorage.getItem('isEnterPressed');
        if (value == 'true') {
          zEvent.preventDefault();
          zEvent.stopImmediatePropagation();

          $('#menuList > li').eq(AsideNavComponent.asideNavComponent.listIndex).css("background-color", "#f2f3f8");
          // $('#menuList > li').removeClass('m-menu__item--open');

          if ($('#menuList > li').eq(AsideNavComponent.asideNavComponent.listIndex).children('div').length > 0) {

            let element = $('#menuList > li').eq(AsideNavComponent.asideNavComponent.listIndex);
            if (!element[0].classList.contains('m-menu__item--open')) {
              $('#menuList > li').eq(AsideNavComponent.asideNavComponent.listIndex).addClass('m-menu__item--open');
            } else {
              var elem = $('#menuList > li').eq(AsideNavComponent.asideNavComponent.listIndex).children('div')
                .eq(AsideNavComponent.asideNavComponent.submenuIndex).children('ul').children('li');

              if (elem[0].classList.contains('m-menu__item--open')) {
                if (AsideNavComponent.asideNavComponent.submenuIndex >= 0) {

                  $('#menuList > li').eq(AsideNavComponent.asideNavComponent.listIndex).children('div')
                    .eq(AsideNavComponent.asideNavComponent.submenuIndex).children('ul').children('li')
                    .children('div')
                    .eq(AsideNavComponent.asideNavComponent.liSubmenuIndex).css("background-color", "#f2f3f8");

                  var ele = $('#menuList > li').eq(AsideNavComponent.asideNavComponent.listIndex).children('div')
                    .eq(AsideNavComponent.asideNavComponent.submenuIndex).children('ul').children('li')
                    .children('div')
                    .eq(AsideNavComponent.asideNavComponent.submenuIndex);

                  var doc = document.createElement("html");
                  var rawHtml = ele.prevObject[AsideNavComponent.asideNavComponent.liSubmenuIndex];
                  doc.innerHTML = rawHtml.outerHTML;
                  var links = doc.getElementsByTagName("a")
                  var urls = [];
                  for (var i = 0; i < links.length; i++) {
                    urls.push(links[i].getAttribute("href"));
                  }
                  AsideNavComponent.asideNavComponent._router.navigateByUrl(urls.toString());
                  localStorage.setItem('isEnterPressed', 'false');
                  localStorage.setItem('isArrowDownPressed', 'false');
                  localStorage.setItem('isArrowUpPressed', 'false');
                  document.getElementById("m_aside_left_close_btn").focus();

                }
              }
            }
          }

          let element = $('#menuList > li').eq(AsideNavComponent.asideNavComponent.listIndex);
          //Check whether menu has opened
          if (element[0].classList.contains('m-menu__item--open')) {
            if ($('#menuList > li').eq(AsideNavComponent.asideNavComponent.listIndex).children('div')
              .eq(AsideNavComponent.asideNavComponent.submenuIndex).children('ul').children('li').children('div').length > 0) {

              if (AsideNavComponent.asideNavComponent.submenuIndex > 0) {
                $('#menuList > li').eq(AsideNavComponent.asideNavComponent.listIndex).children('div')
                  .eq(AsideNavComponent.asideNavComponent.submenuIndex).children('ul').children('li').addClass('m-menu__item--open');

                $('#menuList > li').eq(AsideNavComponent.asideNavComponent.listIndex).children('div')
                  .eq(AsideNavComponent.asideNavComponent.submenuIndex).children('ul').children('li').css("background-color", "#f2f3f8");

              }
            }

            if ($('#menuList > li').eq(AsideNavComponent.asideNavComponent.listIndex).children('div').length > 0) {

              //sub menu ( ul -> li -> div -> ul -> li -> div)
              if ($('#menuList > li').eq(AsideNavComponent.asideNavComponent.listIndex).children('div')
                .eq(AsideNavComponent.asideNavComponent.submenuIndex).children('ul').children('li').children('div').length > 0) {

                $('#menuList > li').eq(AsideNavComponent.asideNavComponent.listIndex).children('div')
                  .eq(AsideNavComponent.asideNavComponent.submenuIndex).children('ul').children('li').children('div').css("background-color", "#f2f3f8");
                // AsideNavComponent.asideNavComponent.liSubmenuIndex = -1;

              } else {

                //sub menu ( ul -> li -> div)

                $('#menuList > li').eq(AsideNavComponent.asideNavComponent.listIndex).children('div').css("background-color", "#f2f3f8");
                var ele = $('#menuList > li').eq(AsideNavComponent.asideNavComponent.listIndex).children('div').eq(AsideNavComponent.asideNavComponent.submenuIndex);

                var doc = document.createElement("html");
                var rawHtml = ele.prevObject[AsideNavComponent.asideNavComponent.submenuIndex];
                doc.innerHTML = rawHtml.outerHTML;
                var links = doc.getElementsByTagName("a")
                var urls = [];
                for (var i = 0; i < links.length; i++) {
                  urls.push(links[i].getAttribute("href"));
                }
                AsideNavComponent.asideNavComponent._router.navigateByUrl(urls.toString());
                localStorage.setItem('isEnterPressed', 'false');
                localStorage.setItem('isArrowDownPressed', 'false');
                localStorage.setItem('isArrowUpPressed', 'false');
                document.getElementById("m_aside_left_close_btn").focus();

              }
            }
          } else {
            var ele = $('#menuList > li > a').eq(AsideNavComponent.asideNavComponent.listIndex);
            AsideNavComponent.asideNavComponent._router.navigateByUrl(ele[0].attributes[1].value);
            localStorage.setItem('isEnterPressed', 'false');
            localStorage.setItem('isArrowDownPressed', 'false');
            localStorage.setItem('isArrowUpPressed', 'false');
            document.getElementById("m_aside_left_close_btn").focus();
          }
        }
      }
    });
  }
  //end

  LoadShowRouteOptimization() {
    this._appService
      .GetById("Common", "GetSystemSettingByName", "ShowRouteOptimization")
      .subscribe(
        (response) => {
          if (response == "1") {
            this.ShowRouteOptimization = true;
          } else {
            this.ShowRouteOptimization = false;
          }
        },
        (err) => {
          this._toastr.error(
            "Error occurred while fetching Status data !",
            "error"
          );
        }
      );
  }

  GetPaymentDone() {
    this._appService.GetById("User", "GetCompanySubscription", this.DefaultCompanyId).subscribe((response) => {
      console.log("response::", response);
      this.isPaymentDone = response[0].Status;
      console.log("isPaymentDone::", this.isPaymentDone);
      if (!this.isPaymentDone) {
        this.openPaymentAlert();
      }
    },
      (error) => {
        console.log("Error while Getting Subscription Data", error);
      });
  }

  openPaymentAlert(): void {
    this.showPaymentAlert = true;
  }

  closePaymentAlert(index: number): void {
    this.Paymentmsg.splice(index, 1); // Remove the specific message by index
    if (this.Paymentmsg.length === 0) {
      this.showPaymentAlert = false; // Hide overlay if there are no more messages
    }
  }


  getpayementmessage() {
    this._appService.Get("User", "getpayementmessage").subscribe((response) => {
      console.log("getpayementmessage", response);
      this.Paymentmsg = response;
      console.log("getpayementmessage::", this.Paymentmsg);
    },
      (error) => {
        console.log("Error while Getting Payment Message Data", error);
      });
  }

}
